import { Directive, OnInit } from "@angular/core";
import jwt_decode from 'jwt-decode';
import { StaticDataService, ISystemCodeLangObject } from "../services/static-data.service";
import { OidcSecurityService } from "angular-auth-oidc-client";
import { SUBSCRIPTIONS } from "app/constants/subscriptions";

@Directive()
export abstract class SubscriptionCheckerComponent implements OnInit {
    readonly subscriptions = new Set<string>();
    readonly systems: ISystemCodeLangObject[] = this.staticService.getDigitalCardSystems();

    constructor(
        protected staticService: StaticDataService,
        protected oidcSecurityService: OidcSecurityService
    ) {}

    ngOnInit(): void {
        let token = this.oidcSecurityService.getToken();
        let tokenData: any = jwt_decode(token);

        Object.entries(tokenData)
          .filter(([_, value]) => value === "licensed")
          .forEach(([key, _]) => {
            this.subscriptions.add(key);
          });
    }
    
    hasSubscription(subscriptionType: string): boolean {
        return this.subscriptions.has(subscriptionType);
    }

    isDigitalCredSubscription(value: string): boolean {
        return this.systems.some(s => s.subscriptionKey === value);
    }
}